import { useInscalar } from '@ilg-core/inscalar-web/react'
import { useCallback } from 'react'

import {
    getCurrentWindowUrl,
    getFeatureFlagsForEvent,
} from '@mediaingenuity/totallymoney.cardloanutils'
import Cookies from 'js-cookie'

import {
    EventType,
    InscalarEventPageView,
} from '@appTypes/InscalarEvents.interface'

import { getInscalarAppEnv } from '@utils/getInscalarAppEnv'

import useFeatureFlags from './useFeatureFlags'

export const COOKIE_CONSENT_KEY = 'cookieyes-consent'

const useLogInscalarEvent = () => {
    const { featureFlags } = useFeatureFlags()
    const { track } = useInscalar()

    const logBase = useCallback(
        (
            eventType: EventType,
            data?: Record<string, any>,
            eventName = 'frontend_event'
        ) => {
            track(
                eventName,
                '8.0',
                {},
                {
                    ...data,

                    // Fields that can't be overridden
                    env: getInscalarAppEnv(),
                    client: 'web',
                    event_type: eventType,
                    filters: {
                        cookie_consents: Cookies.get(COOKIE_CONSENT_KEY),
                        experiment_ids:
                            getFeatureFlagsForEvent(featureFlags)?.split(';') ??
                            [],
                    },
                }
            )
        },
        [featureFlags, track]
    )

    const logPageView = useCallback(
        ({
            journey,
            journeyCategory,
            originalJourney,
            originalJourneyCategory,
            step,
            previousStep,
        }: InscalarEventPageView) => {
            logBase('pageview', {
                journey,
                journey_category: journeyCategory,

                original_journey: originalJourney,
                original_journey_category: originalJourneyCategory,

                step,
                previous_step: previousStep,
            })
        },
        [logBase]
    )

    return {
        logPageView,
    }
}

export default useLogInscalarEvent
